import { IInvoiceType } from 'v2/modules/invoice/interfaces';

import { IWarehouseGroup } from './location-warehouse.interface';
import { ITagOld } from './tag.interface';

export interface IChannelIntegrationMapping {
  id: number;
  channel_id: number;
  appIntegrationAccountId: number;
  omsStoreId: number;
  integrationType: string;
  updatedBy: number;
  createdBy: number;
  deletedBy: number;
  createdAt: Date;
  updatedAt: Date;
  deletedAt: Date;
  options: IChannelIntegrationMappingOptions;
  invoiceType: IInvoiceType;
  inventoryLocationId: number | null;
}

export interface IChannelIntegrationMappingOptions {
  pushStock: boolean;
  omsShippingMethodId: number;
  autoPushOrderAfterMinutes: number;
  pushCustomFields: IChannelPushCustomField[];
  includeIncomingStocksAsSellable: boolean;
  pushIncomingStocksFromSupplierPurchaseOrderEnabled: boolean;
  pushUnitCost: boolean;
  autoPushFulfillmentUpdatesToOrderSource: boolean;
  autoCreateInvoiceEnabled: boolean;
  invoiceTypeId: number;
  invoiceCreateTiming: string;
  incomingCustomFieldMapping: IChannelIncomingCustomFieldMapping[];
  pushOrderCustomFieldMapping: IChannelPushCustomFieldMapping[];
  saveContactToCrmFromIncomingOrders: boolean;
}

export interface IChannelIncomingCustomFieldMapping {
  incomingField: string;
  lumField: string;
}

export interface IChannelPushCustomFieldMapping {
  lumField: string;
  pushField: string;
}

export interface IChannelPushCustomField {
  key: string;
  value: string | number | boolean;
}

export interface IChannel {
  id: number;
  uuid: string;
  label: string;
  description: string | null;
  credentials: any;
  fees: any[];
  filters: any[];
  warehouseGroupId: number;
  warehouseGroup?: IWarehouseGroup | null;
  storeType: number;
  pullOrdersFromOms: boolean;
  getProductsEnabled: boolean;
  pushInventoryEnabled: boolean;
  includeIncomingStocksEnabled: boolean;
  pullStocksEnabled: boolean;
  pullShipmentsEnabled: boolean;
  appIntegrationAccountId: number | null;
  omsStoreId: number | null;
  updatedBy: number;
  createdBy: number;
  createdAt: Date;
  updatedAt: Date;
  enabled: boolean;
  status: number;
  tagIds?: number[] | null;
  tags: ITagOld[] | null;
  pullOrderIntegrationMapping?: IChannelIntegrationMapping | null;
  pushOrderIntegrationMapping?: IChannelIntegrationMapping | null;
  getProductsIntegrationMapping?: IChannelIntegrationMapping | null;
  channelIntegrationMapping: IChannelIntegrationMapping[] | null;
  pushStockIntegrationMapping?: IChannelIntegrationMapping | null;
  pushOrdersToOmsOptions: string;
  getProductsAppIntegrationAccountId: number | null;
  pushStocksAppIntegrationAccountId: number | null;
  pushStocksInventoryLocationId: number | null;
  isPOSChannel: boolean;
  pushIncomingStocksFromSupplierPurchaseOrderEnabled: boolean;
  metafields?: IChannelMeta[] | null;
  invoiceType?: IInvoiceType | null;
  channelType?: string;
}

export interface IChannelMeta {
  id: number;
  metaKey: string;
  metaValue: object | any[];
}

export interface IChannelMetaKeyValue {
  [EChannelMetaKey.CREATE_INVOICE_AUTOMATICALLY_FOR_AN_ORDER]: boolean;
  [EChannelMetaKey.AUTO_SYNC_EDI]: boolean;
  [EChannelMetaKey.CREATE_INVOICE_DEFAULT_INVOICE_TYPE_ID]: number;
  [EChannelMetaKey.CREATE_INVOICE_CREATION_TIMING]: string;
}

export enum EChannelMetaKey {
  CREATE_INVOICE_AUTOMATICALLY_FOR_AN_ORDER = 'create_invoice_automatically_for_an_order',
  CREATE_INVOICE_DEFAULT_INVOICE_TYPE_ID = 'create_invoice_default_invoice_type_id',
  CREATE_INVOICE_CREATION_TIMING = 'create_invoice_creation_timing',
  AUTO_SYNC_EDI = 'auto_sync_edi',
}
